import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQSection() {
  const { t } = useLang();
  const items = [
    { q: t.faq.q1, a: t.faq.a1 },
    { q: t.faq.q2, a: t.faq.a2 },
    { q: t.faq.q3, a: t.faq.a3 },
    { q: t.faq.q4, a: t.faq.a4 },
    { q: t.faq.q5, a: t.faq.a5 },
    { q: t.faq.q6, a: t.faq.a6 },
  ];

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-sand">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="mb-12">
          <div className="font-overline text-terracotta text-xs mb-3">{t.faq.overline}</div>
          <h2 className="font-display text-4xl md:text-6xl text-jungle leading-[1.05]">{t.faq.title}</h2>
        </div>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {items.map((it, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-jungle/15">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-display text-jungle text-lg md:text-2xl py-6 hover:no-underline hover:text-terracotta text-left"
              >
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-forest text-base leading-relaxed pb-6">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
